import clsx from 'clsx';
import { PolymorphicElement } from '../utils/polymorphic-element';
import styles from './style.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BASE_ICON_SIZE = 24;
export default function BoxControlIcon({
  as = 'span',
  size = 24,
  side = 'all',
  sides,
  className,
  ...props
}) {
  const isSideDisabled = value => sides?.length && !sides.includes(value);
  const hasSide = value => {
    if (isSideDisabled(value)) {
      return false;
    }
    return side === 'all' || side === value;
  };
  const top = hasSide('top') || hasSide('vertical');
  const right = hasSide('right') || hasSide('horizontal');
  const bottom = hasSide('bottom') || hasSide('vertical');
  const left = hasSide('left') || hasSide('horizontal');

  // Simulates SVG Icon scaling.
  const scale = size / BASE_ICON_SIZE;
  return /*#__PURE__*/_jsx(PolymorphicElement, {
    as: as,
    style: {
      transform: `scale(${scale})`
    },
    ...props,
    className: clsx(styles['icon-root'], className),
    children: /*#__PURE__*/_jsxs("span", {
      className: styles['icon-viewbox'],
      children: [/*#__PURE__*/_jsx("span", {
        className: clsx(styles['icon-stroke'], styles['icon-top'], {
          [styles['is-highlighted']]: top
        })
      }), /*#__PURE__*/_jsx("span", {
        className: clsx(styles['icon-stroke'], styles['icon-right'], {
          [styles['is-highlighted']]: right
        })
      }), /*#__PURE__*/_jsx("span", {
        className: clsx(styles['icon-stroke'], styles['icon-bottom'], {
          [styles['is-highlighted']]: bottom
        })
      }), /*#__PURE__*/_jsx("span", {
        className: clsx(styles['icon-stroke'], styles['icon-left'], {
          [styles['is-highlighted']]: left
        })
      })]
    })
  });
}